import axios from "axios";

export const getBirthdayReport = async (params) => {
  try {
    const response = await axios.get(`/emp-report/birthdays`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching birthday report:", error);
    throw error;
  }
};

export const getNewAppointmentsReport = async (params) => {
  try {
    const response = await axios.get(`/emp-report/new-appointments`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching new appointments report:", error);
    throw error;
  }
};

export const getResignationReport = async (params) => {
  try {
    const response = await axios.get(`/emp-report/resignations`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching resignation report:", error);
    throw error;
  }
};

export const getMaternityLeaveReport = async (params) => {
  try {
    const response = await axios.get(`/emp-report/maternity-leaves`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching maternity leave report:", error);
    throw error;
  }
};

export const getHrAuditData = async () => {
  const response = await axios.get(`/employees-active`);
  return response.data;
};